import { Link } from "react-router-dom";
import Disclaimer from "../../components/Disclaimer/Disclaimer";
import Layout from "../../components/Layout/Layout";

const About = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          A project of Earthbound Martian
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">About Forteana</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Ghost hunts, cryptids, overnight strangeness. This is a practical,
          free tool for haunted stays, Bigfoot gatherings, UFO weekends, and
          night watches — with dates, a pin, and whether you can sleep nearby.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">The name</h2>
        <p className="leading-relaxed">
          Forteana is Charles Fort’s word for this pile of reports: ghosts,
          cryptids, lights in the sky, things that don’t sit neatly in a
          textbook. The domain can be obscure. The copy is not.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">What v1 is</h2>
        <p className="leading-relaxed mb-4">
          A map of the US (and a door for Canada), a modest curated list, and a
          calendar. Festivals and year-round sites together. Useful first.
          Promotional second. Jefferson, Texas is here because the piney woods
          and the haunted hotels are good — not because the map stops at the
          Sabine.
        </p>
        <p className="leading-relaxed">
          It is not a proof of Bigfoot, a ghost-hunting certification, or a
          substitute for park rules. Lunar anomaly catalogs live at{" "}
          <a
            href="https://lunamalies.earthboundmartian.com"
            className="text-turquoise hover:text-mars"
          >
            Lunamalies
          </a>
          . Dark-sky overnights live at{" "}
          <a
            href="https://darkskies.earthboundmartian.com"
            className="text-turquoise hover:text-mars"
          >
            Darkskies
          </a>
          .
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Data</h2>
        <Disclaimer />
        <p className="leading-relaxed mt-4">
          Dates are taken from organizer calendars for 2026 where we could
          confirm them. Place search uses{" "}
          <a
            className="text-turquoise hover:text-mars"
            href="https://photon.komoot.io"
            target="_blank"
            rel="noreferrer"
          >
            Photon
          </a>{" "}
          (OpenStreetMap).
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Overnight notes</h2>
        <p className="leading-relaxed">
          “Sleep on site” means a hotel hunt, a booked investigation, or park
          camping at the place itself. “Camp nearby” means a realistic overnight
          within a short drive. Pins are not a reservation, not a permit to
          trespass, and not evidence. Private ranches and military land stay
          closed.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Earthbound Martian</h2>
        <p className="leading-relaxed mb-6">
          Forteana is built for people who want a comfortable multi-night stay
          next to the weird. If that is your kind of work, the Landships are
          for that kind of work.
        </p>
        <div className="flex flex-wrap gap-3">
          <a
            href="https://earthboundmartian.com"
            className="inline-block bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
          >
            Visit Earthbound Martian
          </a>
          <Link
            to="/contact"
            className="inline-block border border-alt-blk px-8 py-4 rounded-2xl font-semibold hover:bg-alt-blk hover:text-white transition-colors"
          >
            Contact
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default About;
